module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('VTitle', {
    attrs: {
      "page-title": "老师评语"
    }
  })], 1), _vm._v(" "), (_vm.data.length) ? _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.data), function(obj, index) {
    return _c('VMessage', {
      key: index,
      attrs: {
        "obj": obj
      }
    })
  }), 1) : _c('div', {
    staticClass: "nothing"
  }, [_vm._v("\n    您还没有评语噢~\n  ")]), _vm._v(" "), _c('div', [_c('VGoBackBtn')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f239327"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Myrecord/TecComment.vue
// module id = 767
// module chunks = 1